import * as React from "react";
import * as ReactDOM from "react-dom";
import { IOWidget, Options, Fun, option, mk_widget } from "../widget";

export interface PromiseOptions<i,o> extends Options {
  on_fail:(reason:any) => o,
  call_promise_when_receive_new_props?:true
}

export interface PromiseProps<i,o> {
  options:PromiseOptions<i,o>
  input:i,
  actual_promise:Fun<i,Promise<o>>,
  on_done:(output:o) => void
}
export interface PromiseState<i,o> {

}

export class PromiseComponent<i,o> extends React.Component<PromiseProps<i,o>, PromiseState<i,o>> {
  constructor(props:PromiseProps<i,o>, context:any) {
    super(props, context)

    this.state = {}
  }

  status?:"running" | "done" | "failed"
  run_promise(i:i) {
    if (this.status == "running") return
    this.status = "running"
    this.props.actual_promise(i)
      .then(res => {
        this.status = "done"; this.props.on_done(res)
      })
      .catch(reason => {
        this.status="failed";
        if (this.props.options && this.props.options.on_fail)
          this.props.on_done(this.props.options.on_fail(reason))
      })
  }

  componentWillReceiveProps(newProps:PromiseProps<i,o>) {
    if (option("call_promise_when_receive_new_props", this.props.options)) this.run_promise(newProps.input)
  }

  componentDidMount() {
    this.run_promise(this.props.input)
  }

  render() {
    return <div key={`${option("key", this.props.options)}-inner`} className={this.status} />
  }
}

export let promise = function<i, o>(p:Fun<i,Promise<o>>, options:PromiseOptions<i,o>) : IOWidget<i, o> {
  return (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<PromiseProps<i,o>>(PromiseComponent, { on_done, input, options, actual_promise:p, key: options.key })
  })
}
